export default "__VITE_ASSET__DPi_d2EF__"